import React from 'react';
import PropTypes from 'prop-types';
import { Delete } from '@material-ui/icons';
import { motion, AnimatePresence } from 'framer-motion';
import PopupWrapper from '../PopupWrapper';
import Button from '../Button/Button';
import ResourceStatePill from '../ResourceStatePill';

const BannerActionsAndInfo = props => {
  const { bannerState, isDeleted, configIndex } = props;
  return (
    <div className="flex justify-between items-start mb-8">
      <div className="flex items-start">
        <ResourceStatePill state={bannerState} />
        {isDeleted && (
          <div className="rounded-full text-xs px-2 leading-loose tracking-wide inline-block bg-lightRed ml-4">
            DELETED
          </div>
        )}
      </div>
      {!isDeleted && (
        <PopupWrapper
          className="relative h-6"
          isOpen={props.showDeleteWarningPopup === configIndex}
          togglePopup={props.toggleDeleteWarningPopup}>
          <Button
            type="transparent"
            className="p-0-important shadow-none-important h-6"
            onClick={() =>
              bannerState === 'DRAFT'
                ? props.toggleDeleteWarningPopup(configIndex)
                : props.removeConfig(configIndex)
            }>
            <Delete className="text-darkGrey" />
          </Button>
          <AnimatePresence>
            {props.showDeleteWarningPopup === configIndex && (
              <motion.div
                initial={{ opacity: 0, x: '-70%', y: '0%' }}
                animate={{ opacity: 1, x: '-102%' }}
                exit={{ opacity: 0, x: '-70%' }}
                transition={{
                  ease: [0.18, 0.89, 0.39, 1.4],
                  duration: 0.3,
                }}
                className="absolute pin-t pin-l px-2 py-4 bg-white shadow-lg rounded text-left w-64">
                <div className="text-center leading-normal">
                  Are you sure you want to discard this draft?
                </div>
                <div className="flex justify-around mt-8">
                  <Button
                    className="h-8"
                    onClick={props.toggleDeleteWarningPopup}>
                    No
                  </Button>
                  <Button
                    type="red-transparent"
                    className="h-8"
                    onClick={() => props.removeConfig(configIndex)}>
                    Yes, discard it
                  </Button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </PopupWrapper>
      )}
    </div>
  );
};

BannerActionsAndInfo.propTypes = {
  state: PropTypes.string,
  toggleDeleteWarningPopup: PropTypes.func,
  removeConfig: PropTypes.func,
  configIndex: PropTypes.number,
  showDeleteWarningPopup: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
  ]),
  bannerState: PropTypes.string,
  isDeleted: PropTypes.bool.isRequired,
};

export default  BannerActionsAndInfo;
